/**
 * @generated SignedSource<<7d0c7ed4a4b10d05234751eb86a0a1ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AccountSetupWizardDefaultFlagsQuery$variables = {};
export type AccountSetupWizardDefaultFlagsQuery$data = {
  readonly adminListFeatureFlags: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type AccountSetupWizardDefaultFlagsQuery = {
  response: AccountSetupWizardDefaultFlagsQuery$data;
  variables: AccountSetupWizardDefaultFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminFeatureFlag",
    "kind": "LinkedField",
    "name": "adminListFeatureFlags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSetupWizardDefaultFlagsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountSetupWizardDefaultFlagsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6fb0f27dec6d5ee9f30c2cb464232bbc",
    "id": null,
    "metadata": {},
    "name": "AccountSetupWizardDefaultFlagsQuery",
    "operationKind": "query",
    "text": "query AccountSetupWizardDefaultFlagsQuery {\n  adminListFeatureFlags {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "92b5656df35ed5e6609083c8e0fe9712";

export default node;
